import { useState } from "react";

interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
  rows?: number;
}

export function JsonEditor({ value, onChange, rows = 12 }: JsonEditorProps) {
  const [error, setError] = useState<string | null>(null);

  function handleChange(next: string) {
    onChange(next);
    try {
      if (next.trim().length > 0) JSON.parse(next);
      setError(null);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  function prettyPrint() {
    try {
      const parsed = JSON.parse(value);
      onChange(JSON.stringify(parsed, null, 2));
      setError(null);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <div className="json-editor">
      <div className="json-editor-toolbar">
        <button type="button" className="btn-secondary" onClick={prettyPrint}>
          Format
        </button>
        {error && <span className="json-editor-error">{error}</span>}
      </div>
      <textarea
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        rows={rows}
        spellCheck={false}
        className="json-editor-textarea"
      />
    </div>
  );
}
